import { Box } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

const PreBillingCustomerAdjustmentApplied = ({ event }: { event: any }) => {
  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        <EventBy event={event} /> applied a pre-billing customer adjustment
      </Box>
    </Box>
  );
};

export default PreBillingCustomerAdjustmentApplied;
